import { Fade, Grid, Typography } from "@mui/material"
import { MobileTabWrapper } from "../Layout"
import StatsBox, { StatsBoxType } from "../components/commons/StatsBox"
import { LeaderboardTable, MyReferralTable } from "../components/rewards"
import useGlobalStore from "../stores/global"
import { useEffect } from "react"

const statsBoxPlaceHolder: StatsBoxType[] = [
  { title: 'My Rank', content: '0', type: 'number', minDecimals: 0 },
  { title: 'Deposit Points', content: '0', type: 'number', minDecimals: 0 },
  { title: 'Borrow Points', content: '0', type: 'number', minDecimals: 0 },
  { title: 'Referral Points', content: '0', type: 'number', minDecimals: 0 },
  { title: 'Total Points', content: '0', type: 'number', minDecimals: 0 },
]

const Rewards = () => {
  const getReferrer = useGlobalStore((state) => state.getReferrer)
  useEffect(() => {
    getReferrer()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const statsBox: StatsBoxType[] = statsBoxPlaceHolder.map((stats) => {
    let content: number | string = '0'
    switch (stats.title) {
      case 'My Rank':
        content = 1
        break;
      case 'Deposit Points':
        content = 100
        break;
      case 'Borrow Points':
        content = 100
        break;
      case 'Referral Points':
        content = 100
        break;
      case 'Total Points':
        content = 300
        break;
    }
    return { ...stats, content: content }
  })
  return (
    <Grid container rowGap={{ xs: 2, sm: 4 }}>
      <Fade in={true} timeout={400}>
        <Grid item container justifyContent={'space-between'} alignItems={'center'}>
          <Grid item sx={{ maxWidth: '100%' }}>
            <Typography variant="h3">MEME POINTS</Typography>
            <Typography sx={{ display: { sm: 'inline', xs: 'block' }, margin: { sm: 0, xs: '1rem 0rem' }, lineHeight: { xs: '1.5rem', sm: 1.6 } }} component={'span'} variant="h5">
              GET REWARDED ON MEMELEND. DEPOSIT,BORROW,REFER TO EARN POINTS.
            </Typography>
          </Grid>
        </Grid>
      </Fade>

      <Grid item container spacing={{ xs: 1.2, sm: 3 }}>
        {
          statsBox.map((stats, index) => {
            return <Fade in={true} timeout={400 * (index + 1)}>
              <Grid item container width={'100%'} xs={6} lg={2.4}>
                <StatsBox key={stats.title} {...stats} />
              </Grid>
            </Fade>
          }
          )
        }
        <Grid item container spacing={3} sx={{ marginTop: { xs: '-1rem', sm: 'inherit' } }}>
          <MobileTabWrapper frameless tabsName={['My Referrals', 'Leaderboard']} tabs={[<MyReferralTable />, <LeaderboardTable />]} />
        </Grid>
      </Grid>
    </Grid >
  )
}

export default Rewards